(function() {
	angular.module('pphhApp')
		.controller("queriesController", ["$rootScope", "$scope", "$window","$q", "$http", "$mdDialog",
			"QueryService", "GisService", "pphhEnv", "CommonCatalogService", QueriesController]);

	function QueriesController($rootScope, $scope, $window,$q, $http, $mdDialog, queryService, gisService, pphhEnv, commonCatalogService) {
		var self = this;
		var initialized = false;
		self.module = null;
		self.versionId = null;

		$scope.queryGroups = [];

		$scope.pageSize = 25;
		$scope.filter = {
			allPlans: 1
		};
		$scope.qfilter = {};
		$scope.groupingInfo = [];
		$scope.metadata = [];
		$scope.hiddenCols = {};
		$scope.hiddenColsLength = 0;
		$scope.colsTable = [];

		$scope.totalItemCount = 0;
		$scope.start = 0;
		$scope.end = 0;

		$scope.init = init;
		$scope.queryGroups = queryGroups;
		$scope.execute = execute;
		$scope.downloadPDF = downloadPDF;
		$scope.openGis = openGis;
		$scope.openGisMultiple=openGisMultiple;
		$scope.openQueryExplanation = openQueryExplanation;
		$scope.rolChange = rolChange;
		$scope.generalChange = generalChange;
		$scope.gotoDetail = gotoDetail;
		$scope.gotoSummary = gotoSummary;
		$scope.gotoCRUD = gotoCRUD;
		$scope.toggleVisibility = toggleVisibility;
		$scope.setComparisionType = setComparisionType;
		$scope.checkedBooleanQuickFilter = checkedBooleanQuickFilter;
		$scope.indeterminateBooleanQuickFilter = indeterminateBooleanQuickFilter;
		$scope.changeIndeterminateBooleanQuickFilter = changeIndeterminateBooleanQuickFilter;
		$scope.doSearch = doSearch;
		$scope.doSearchPlan = doSearchPlan;
		$scope.clearFilter = clearFilter;
		$scope.doFilter = doFilter;
		$scope.download = download;
		$scope.downloadAllPDF = downloadAllPDF;
		$scope.afterInit = null;
		

		function init(module, queryName, versionId) {
              self.module = module;
              self.versionId = versionId;

              $scope.queryName = queryName;

              var promiseCiclos = getCiclos();

              promiseCiclos.then(function() {
                   return getDemarcaciones();
              }).then(function() {
                   return customInit();
              }).then(function() {
                   // La obtención de la información de las columnas se hace después de obtener los ciclos
                   return getMetadata(function() {
                        $scope.colsTable = $scope.metadata.slice();
                        generateGroupingInfo();
                   });
             }).then(function() {
                   $scope.$watch("filter.ciclo", function(newVal, oldVal) {
                        if (newVal != null && oldVal != null && newVal !== oldVal) {
                            getMetadata(function() {
                                 generateGroupingInfo();
                            });
                        }
                   });

                   if ($scope.queryName === "listadoSituacionMedidas") {
                        $scope.$watch("filter.ph", function(newPh, oldPh) {
                            if (newPh != null && oldPh != null && newPh !== oldPh) {
                                 getMetadata(function() {
                                      generateGroupingInfo();
                                 });
                            }
                        });
                   }

                   $rootScope.$on("dsbParamChange", function(event, dashboard, parameter) {
                        if (parameter.name === "version") {
                            $scope.filter.ciclo = parameter.values[0];
                            doSearch();
                        }
                   });
              }).then(function() {
                   initialized = true;
                   if ( $scope.afterInit != null ){
                  		$scope.afterInit ();
                  		$scope.afterInit = null;
                   }
              });

			// En este caso no se necesita invocar getQueryInfo pq se ha hecho de otra manera
			if ($scope.queryName != "listadoResumenMedidas") {
				getQueryInfo();
	     	}
		}

         function customInit() {
              var promise = null;
              if ($scope.queryName === 'listadoInversionHorizontes') {
                   promise =  getHorizontes().then(function() {
                        return getCcaas();
                   });

              } else if ($scope.queryName === "listadoSituacionMedidas") {
                   promise =  getPlanesHidrologicos().then(function() {
                        $scope.filter.ph = 2;
                   });

			  } else if ($scope.queryName === "listadoResumenMedidas" || $scope.queryName === "listadoResumenMedidasAdmonCompetente" || $scope.queryName === "listadoResumenMedidasInversiones"){
				  promise = commonCatalogService.getPlanHidrolActivo($scope.filter.ciclo).then(function(response) {
				  	$scope.filter.ph = response.data;
				  });

              } else if ($scope.queryName === "listadoOIGs" || $scope.queryName === "listadoViabilidadOIGs" ||
            		  $scope.queryName === "listadoDepuradorasMedidasQMedidasPdm" ) {
                   promise =  getCcaas();

              } else if ($scope.queryName === "listadoResponsabilidadAC") {
                   promise =  getPlanesHidrologicos().then(function() {
                   		return getAuxAdmClasif();
                   }).then(function() {
                   		return getRolesAgua();
                   }).then(function() {
                   		return getResponGeneralAgua();
					}).then(function() {
                   		return getResponParticularAgua();
                   	});
              } else if ($scope.queryName === "listadoEvolucionMasasSuperficiales" ||
                   $scope.queryName === "listadoEvolucionMasasSubterraneas") {
                   promise =  getCiclosPlanes().then(function() {
                   		$scope.filter.ph = 3;
                   });
              } else if($scope.queryName === "listadoMedidasInversionHorizontes"){
            	   promise = getDemarcaciones();

              } else if ($scope.queryName === 'listadoMedidasInversionCCAA') {  
				promise =  getHorizontes().then(function() {
                   		$scope.filter.horizonte = $scope.horizontes[0].horizonteName;
				});
  			  } else if ($scope.queryName === "listadoAglomeracionesMedidasQMedidasPdm"
  			 	|| $scope.queryName === "listadoCumplimientoArtQuinceAglomeracion"
  			 	|| $scope.queryName === "listadoCumplimientoArtQuinceDepuradora"
  			  		) {
  				 promise =  getCcaasARU();
			  }
			  
			  return promise;
         }


		function queryGroups() {
			queryService.queryGroups()
				.then(function(response) {
					var groups = response.data;
					$scope.queryGroups = groups;
				});
		}

		function execute(queryName) {
			$window.location.href = pphhEnv.global.contextPath + "/queries/" + queryName;
		}

		function rolChange() {
			getResponGeneralAgua();
		}

		function generalChange() {
			getResponParticularAgua();
		}

		function gotoDetail(url) {
			gotoSummary(url);
		}

		function gotoSummary(url) {

			var targetUrl = url;
			if (targetUrl.indexOf('?') < 0) {
				targetUrl += "?";
			} else {
				targetUrl += "&";
			}
			if ($scope.filter.ciclo != null) {
				targetUrl += "ciclo=" + $scope.filter.ciclo;
			}
			$window.location.href = targetUrl;
		}

		function gotoCRUD(colName, instanceId, row) {
			var col = findColumnMetadata(colName);

			if (col && col.entityName) {
				var entityName = null;
				if (col.entityName.indexOf("=") === 0) {
					entityName = row[col.entityName.substring(1)];
				} else {
					entityName = col.entityName;
				}
				$window.location.href =
					pphhEnv.global.contextPath + "/queries-visor"
					+ "?cicloId=" + $scope.filter.ciclo
					+ "&module=" + self.module
					+ "&entityName=" + entityName
					+ "&instanceId=" + instanceId
					+ "&queryName=" + $scope.queryName
					;
			}
		}

		function findColumnMetadata(columnName) {
			var col = null;
			for (var i = 0; i < $scope.metadata.length; i++) {
				if ($scope.metadata[i].name === columnName) {
					col = $scope.metadata[i];
					break;
				}
			}

			return col;
		}

		function toggleVisibility(colName) {
			if ($scope.hiddenCols[colName]) {
				$scope.hiddenCols[colName] = false;
				$scope.hiddenColsLength--;
			}
			else {
				$scope.hiddenCols[colName] = true;
				$scope.hiddenColsLength++;
			}
		}

		function setComparisionType(col, comparisionType) {
			$scope.qfilter[col.name].comparisionType = comparisionType;
		}

		function checkedBooleanQuickFilter(filter) {
			return filter.value === true;
		}

		function indeterminateBooleanQuickFilter(filter) {
			return !(filter.value === true || filter.value === false);
		}

		function changeIndeterminateBooleanQuickFilter(filter) {
			if (filter.value === true) {
				filter.value = false;
			} else if (filter.value === false) {
				filter.value = null;
			} else {
				filter.value = true;
			}
			return true;
		}

		function doSearch() {
			if ($scope.tblCtrl) {
				SmartTableUtils.reset($scope.tblCtrl.tableState());
				$scope.tblCtrl.pipe();
			}
		}

		function doSearchPlan() {
			commonCatalogService.getPlanHidrolActivo($scope.filter.ciclo).then(function(response) {
				$scope.filter.ph = response.data;
				doSearch();
			});

		}

		function clearFilter() {
			var form = $scope.filterForm;
			if (form) {
				form.$setPristine();
			}

			// clear the form
			$scope.filter = {};
			$scope.filter.ciclo = $scope.ciclos[$scope.ciclos.length-1].id;
			$scope.filter.allPlans = 1;

			angular.forEach($scope.qfilter, function(filter) {
				filter.value = null;
			});

			// Inicia las consultas específicas
			if ($scope.queryName === "listadoSituacionMedidas") {
				$scope.filter.ccaa= $scope.auxCcaa[0].id;
				$scope.filter.ph = 2;
			} else if($scope.queryName === "listadoMedidasInversionHorizontes"){
				$scope.rbds = [];
			}  else if($scope.queryName === "listadoEvolucionMasasSuperficiales" ||
	                $scope.queryName === "listadoEvolucionMasasSubterraneas") {
				$scope.filter.ph = 3;
			} 
			
			SmartTableUtils.reset($scope.tblCtrl.tableState());
			$scope.tblCtrl.pipe();
		}

		//7696 - Añadimos soporte para obtener la consulta con ids solo de manera masiva.
		function doFilterAllIds ( ){
			var deferred = $q.defer();
			var params = buildParamObject();
			queryService.queryIds($scope.queryName, params)
				.then ( function(response){
					deferred.resolve ( response.data );// enviamos los ids.
				},
				function(error) {
					$mdDialog.show(
						$mdDialog.alert({
							title: UIMessages.dialog.confirm.title,
							textContent: "Error query",
							ok: UIMessages.dialog.confirm.cerrar,
							multiple: true
						}));
					$scope.isLoading = false;
				});
			return deferred.promise;
		}

		function doFilter(tableState, ctrl) {
			if (!$scope.tblCtrl && ctrl) {
				$scope.tblCtrl = ctrl;
			}

			if (!tableState && $scope.tblCtrl) {
				$scope.tblCtrl.pipe();
				return;
			}

			if (!initialized) {
				// si no se ha terminado de inicializar indicamos que cuando termine
				// se lanze la consulta.
				$scope.afterInit  = function (){
					$scope.tblCtrl.pipe();
				}
				return;
			}
			$scope.isLoading = true;

			var params = buildParamObject();
			var fullFilter =
				SmartTableUtils.copyAndSetGenericPaginationParams(
					tableState, params);
			queryService.query($scope.queryName, fullFilter)
				.then(
					function(response) {
						var results = response.data.results;

						for (var i = 0; i < results.length; i++) {
							var row = results[i];

							angular.forEach(row, function(value, columnName) {
								if (value == null) {
									return;
								}
								var columnMetadata = findColumnMetadata(columnName);
								if (columnMetadata != null && columnMetadata.date === true) {
									row[columnName] = moment(value).toDate();
								}
							});
						}

						$scope.filterResults = results;
						$scope.colsTable = $scope.metadata.slice();

						SmartTableUtils.updateTableState(tableState, response.data);

						var start = response.data.page * $scope.pageSize;
						var end = (response.data.page * $scope.pageSize) + $scope.pageSize;
						var totalItemCount = response.data.count;

						$scope.doFilterInfo = doFilterInfo(start, end, totalItemCount);
						$scope.isLoading = false;
					},
					function(error) {
						$mdDialog.show(
							$mdDialog.alert({
								title: UIMessages.dialog.confirm.title,
								textContent: "Error query",
								ok: UIMessages.dialog.confirm.cerrar,
								multiple: true
							}));
						$scope.isLoading = false;
					});
		}

		function doFilterInfo(start, end, totalItemCount) {

			if (totalItemCount > 0) {
				$scope.start = start || 0;
				$scope.end = start + $scope.pageSize;
				if (end > totalItemCount) {
					$scope.end = totalItemCount;
				}
				$scope.totalItemCount = totalItemCount || 0;
			}

			if ($scope.end > $scope.totalItemCount) {
				$scope.end = totalItemCount;
			}
			return doFilterInfo;
		}

		function buildParamObject() {
			var params = {};
			angular.forEach($scope.filter, function(value, key) {
				if (value != null) {
					params[key] = value;
				}
			});

			angular.forEach($scope.qfilter, function(field, key) {
				if (angular.isDefined(field.value) && field.value != null) {
					params["q_" + key] = field.value;
					params["q_op_" + key] = field.comparisionType;
				}
			});

			return params;
		}

		function download(queryName) {
			var url = pphhEnv.global.contextPath + "/queries-dwn/" + queryName;

			var i = 0;
			var fullFilter = buildParamObject();
			for (var p in fullFilter) {
				if (fullFilter.hasOwnProperty(p) && fullFilter[p] != null) {
					if (i == 0) {
						url += "?";
					}
					else {
						url += "&";
					}
					i++;

					url += p + "=" + fullFilter[p];
				}
			}

			$window.open(url);
		}

		function downloadAllPDF(queryName) {
			var tableState = $scope.tblCtrl.tableState();
			var fullFilter = SmartTableUtils.copyAndSetGenericPaginationParams(
				tableState, $scope.filter);

			var filterScreen = $scope.filterResults;
			var url = pphhEnv.global.contextPath + "/queries-pdf/" + queryName;

			var i = 0;

			for (var p in fullFilter) {
				if (fullFilter.hasOwnProperty(p)) {
					if (i == 0) {
						url += "?";
					}
					else {
						url += "&";
					}
					i++;

					url += p + "=" + fullFilter[p];
				}
			}

			for (p in filterScreen) {
				if (filterScreen.hasOwnProperty(p)) {
					url += "&";
					i++;
					if (queryName === "medidas") {
						url += "id=" + filterScreen[p].medidaId;
					} else {
						url += "id=" + filterScreen[p].id;
					}
				}
			}
			url = url + "&cicloId=" + $scope.filter.ciclo;
			$window.open(url);
		}

		$scope.$watch("hiddenColsLength", function() {
			generateGroupingInfo();
		});

		function generateGroupingInfo() {
			var grouping = [];
			var currentGroup = null;
			angular.forEach($scope.metadata, function(col) {
				if ($scope.hiddenCols[col.name]) {
					return;
				}

				var groupName = col.group;
				var groupDescription = col.groupDescription;
				if (!groupName) {
					groupName = "_";
				}

				if (currentGroup == null || currentGroup.name !== groupName) {
					if (currentGroup != null) {
						grouping.push(currentGroup);
					}
					currentGroup = {
						name: groupName,
						label: groupDescription,
						count: 0
					};
				}

				currentGroup.count += 1;
			});

			if (grouping.length === 1 && grouping[0].name === "_") {
				grouping = [];
			}

			$scope.groupingInfo = grouping;
		}

		function getMetadata(callback) {

			var fullFilter = buildParamObject();
			return queryService.getMetadata($scope.queryName, fullFilter)
				.then(
					function(response) {
						$scope.metadata = response.data.metadata;
						var lastFilter = response.data.filter;
						if (lastFilter) {
							angular.forEach(lastFilter, function(param, name) {
								$scope.filter[name] = param.first;
							});
						}

						for (var i = 0; i < $scope.metadata.length; i++) {
							var col = $scope.metadata[i];
							$scope.qfilter[col.name] = {
								comparisionType: col.comparisionType,
								value: null
							};
						}

						if (response.data.qfilter) {
							angular.forEach(response.data.qfilter, function(param) {
								$scope.qfilter[param.name].value = param.value;
							});
						}
						callback();
					});

		}

		function getQueryInfo() {
			$http.get("/queries/" + $scope.queryName + "/info")
				.then(
					function(response) {
						$scope.queryInfo = response.data.queryInfo;
					});
		}

		function getCiclos() {
			return queryService.getCiclos($scope.queryName, self.module)
				.then(
					function(response) {
						$scope.ciclos = response.data;
						if (self.versionId != null) {
							$scope.filter.ciclo = self.versionId;
							self.versionId = null;
						} else if ($scope.filter.ciclo == null) {
							$scope.filter.ciclo = $scope.ciclos[$scope.ciclos.length - 1].id;
						}
					});
		}

		function getDemarcaciones() {
			var url = null;
			if ($scope.queryName === 'listadoMedidasDSEAR') {
				url = "/cc/queries/todasDemarcaciones";
			} else {
				url = "/cc/queries/demarcaciones?cicloId=" + $scope.filter.ciclo;
			}

			return $http.get(url).then(
				function(response) {
					$scope.rbds = response.data;
				});
		}

		function getHorizontes() {
			return $http.get("/queries/horizontes")
				.then(
					function(response) {
						$scope.horizontes = response.data;
					});
		}

		function getCcaas() {
			return $http.get("/cc/ccaa")
				.then(
					function(response) {
						$scope.ccaas = response.data;
					});
		}

		function getCcaasARU() {
			return $http.get("/cc/ccaa")
				.then(
					function(response) {
						$scope.auxCcaa = response.data;
						if ($scope.auxCcaa.length === 1 ) {
							$scope.filter.ccaa = $scope.auxCcaa[0].id;
						}
					});
		}

		function getAuxAdmClasif() {
			return $http.get("/queries/clasifAdmComp")
				.then(
					function(response) {
						$scope.admClasif = response.data;
					});
		}

		function getRolesAgua() {
			return $http.get("/queries/rolesAgua")
				.then(
					function(response) {
						$scope.rolesAgua = response.data;
					});
		}
		function getResponGeneralAgua() {
			var params = "rol=";
			if ($scope.filter.rolAgua) {
				params = params + $scope.filter.rolAgua;
			}

			return $http.get("/queries/responGeneralAgua?" + params)
				.then(
					function(response) {
						$scope.respGenAgua = response.data;
					});
		}

		function getResponParticularAgua() {
			var params = "general=";
			if ($scope.filter.respGenAgua) {
				params = params + $scope.filter.respGenAgua;
			}

			return $http.get("/queries/responParticularAgua?" + params)
				.then(
					function(response) {
						$scope.respPartAgua = response.data;
					});
		}


		function getPlanesHidrologicos() {
			return $http.get("/cc/pphh")
				.then(
					function(response) {
						$scope.pphh = response.data;
					});
		}

		function getCiclosPlanes() {
			return $http.get("/cc/cicloPlanes")
				.then(
					function(response) {
						$scope.cicloPlanes = response.data;
					});
		}

		function downloadPDF(entityName, id) {
			var ciclo = $scope.filter.ciclo;
			var url = pphhEnv.global.contextPath + "/queries-pdf/" + entityName + "/" + id + "/" + ciclo;
			$window.open(url);
		}

		/**
		 * Comunica al servicio de geolocalización que un determinado elemento
		 * se quiere localizar en el visor. También se puede no indicar ningún
		 * elemento concreto y en ese caso se solicita al servicio abrir el visor
		 * geográfico con las capas correspondientes al origen.
		 */
		function openGis(origen, row) {
			if (row) {
				var id = null;
				if (origen === 'MED') {
					id = row.medidaId;
				} else {
					id = row.id;
				}

				gisService.openViewer(origen, id);
			} else {
				gisService.openEmptyViewer(origen, $scope.filter.ciclo);
			}

			$window.scrollTo(0, 0);
		}
		// 7696 Soporte para apertura de multiples ids en gis
		function openGisMultiple ( origen ){
				$window.scrollTo(0, 0);
				$scope.isLoading = true;
			doFilterAllIds().then ( function(data){
				var ids = data
				if ( ids ){
					gisService.openViewerMultiple(origen, ids,true).then ( function () {$scope.isLoading=false;});
				} else {
					gisService.openEmptyViewer(origen, $scope.filter.ciclo);
					$scope.isLoading=false;
				}
				

			
			});

		}

		function openQueryExplanation() {
			var alert = $mdDialog.alert()
				.clickOutsideToClose(true)
				.htmlContent($scope.queryInfo.description)
				.ok(UIMessages.dialog.confirm.cerrar)
				;
			$mdDialog.show(alert);
		}
	}
})();